import { createBrowserClient } from '@supabase/ssr';
import { guardHeldLeaveWriterRpcClient } from '@statura/utils/leave-revoked-writer-rpc-guard';
import { createSupabaseReadRetryFetch } from '@statura/utils/supabase-fetch-retry';

const supabaseFetch = createSupabaseReadRetryFetch();

// NOTE: `createBrowserClient` is ALREADY a per-tab singleton in the browser.
// With no `isSingleton` option it caches and returns one shared client whenever
// `isBrowser()` is true (see @supabase/ssr createBrowserClient), so calling
// `createClient()` from many components does NOT spawn multiple GoTrueClient
// instances — every call hands back the same cached client. Do not add a manual
// memo expecting to "fix duplicate clients"; there are none to fix. (Auth-path
// review, 2026-06-23.)
export function createClient() {
  return guardHeldLeaveWriterRpcClient(
    createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        // These match @supabase/ssr's browser defaults; we set them explicitly so a
        // future library default change can't silently disable silent token refresh.
        // With autoRefreshToken on, an active tab keeps its access token fresh in the
        // background, so the idle auto-logout (session-security-provider) is the only
        // thing that ends an active session — and only after real inactivity, not
        // because a token quietly expired mid-task.
        auth: {
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: true,
        },
        global: {
          fetch: supabaseFetch,
        },
      },
    ),
  );
}
